module.exports = __webpack_public_path__ + "img/centerRight.91a6ff00.png";